export default __webpack_public_path__ + "static/media/img-content.a19e71d9.jpg";